var isNumber = require('./isNumber');

module.exports = function isArrayLike(obj){
	if(typeof obj === 'undefined'){return false;}
	return  isNumber(obj.length) && (obj.length == 0 || (0 in obj))
}


/*****************
 ** WEBPACK FOOTER
 ** ./lib/isArrayLike.js
 ** module id = 25
 ** module chunks = 0
 **/